var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomiseResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 207,
    viewBox: "0 0 292 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10890_59301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.669 0.699951H15.3312C6.86403 0.699951 0 7.69221 0 16.3176V190.782C0 199.408 6.86403 206.4 15.3312 206.4H276.669C285.136 206.4 292 199.408 292 190.782V16.3176C292 7.69221 285.136 0.699951 276.669 0.699951Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.589 47.2278H14.9323C12.4141 47.2278 10.3728 49.3073 10.3728 51.8724V75.595C10.3728 78.1602 12.4141 80.2396 14.9323 80.2396H276.589C279.107 80.2396 281.149 78.1602 281.149 75.595V51.8724C281.149 49.3073 279.107 47.2278 276.589 47.2278Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.589 130.146H14.9323C12.4141 130.146 10.3728 132.226 10.3728 134.791V158.514C10.3728 161.079 12.4141 163.158 14.9323 163.158H276.589C279.107 163.158 281.149 161.079 281.149 158.514V134.791C281.149 132.226 279.107 130.146 276.589 130.146Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.843 12.9502H99.1117C97.0153 12.9502 95.3159 14.6814 95.3159 16.8169V27.7202C95.3159 29.8557 97.0153 31.5869 99.1117 31.5869H192.843C194.939 31.5869 196.639 29.8557 196.639 27.7202V16.8169C196.639 14.6814 194.939 12.9502 192.843 12.9502Z",
    stroke: "#D02E0A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.983 18.8721V25.6649",
    stroke: "#D02E0A",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.311 22.2627H142.643",
    stroke: "#D02E0A",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.581 95.8804H98.8495C96.7531 95.8804 95.0537 97.6115 95.0537 99.747V110.65C95.0537 112.786 96.7531 114.517 98.8495 114.517H192.581C194.677 114.517 196.377 112.786 196.377 110.65V99.747C196.377 97.6115 194.677 95.8804 192.581 95.8804Z",
    stroke: "#D02E0A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.721 101.802V108.584",
    stroke: "#ED1C24",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.049 105.193H142.381",
    stroke: "#ED1C24",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.495 178.799H96.7635C94.6672 178.799 92.9678 180.53 92.9678 182.666V193.569C92.9678 195.705 94.6672 197.436 96.7635 197.436H190.495C192.591 197.436 194.291 195.705 194.291 193.569V182.666C194.291 180.53 192.591 178.799 190.495 178.799Z",
    stroke: "#D02E0A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.624 184.721V191.514",
    stroke: "#D02E0A",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 188.123H140.295",
    stroke: "#D02E0A",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.337 35.7091L206.27 41.7239L209.109 37.8457L201.175 31.8308L203.934 28.0571L196.981 27.2326L190.027 26.4082L192.809 32.9456L195.578 39.4945L198.337 35.7091Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10890_59301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 205.7,
    fill: "white",
    transform: "translate(0 0.699951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomiseResource);
export default __webpack_public_path__ + "static/media/customise-resource.aac83fdf24a20855575a1bc7060df7af.svg";
export { ForwardRef as ReactComponent };